import { IAclFilter } from "../../store/queries/acl-filter.interface";
import { createSelector } from "reselect";
import { AclFilter } from "../../store/queries/acl-filter";
import { dictionarySelector, listSelector } from "../query-facade";
import { IAclFilterCustomCheck } from "../../store/queries/acl-filter-custom-check.interface";
import { VasState } from "../../store/store-type";
import { isInArray } from "../../../core/util/is-in-array";
import { JobQueryFactory } from "../job/job.queries";
import { JobData } from "../job-data/job-data.model";
import { AppConfig } from "../../../app/app.config";

export class JobDataAclFilter<T extends JobData> extends AclFilter<T> implements IAclFilter<T> {

    constructor(protected customChecks: Array<IAclFilterCustomCheck<T>> = [], protected jobQueryFactory: JobQueryFactory) {
        super(customChecks);
    }

    createSelector(idsSelector: listSelector<string>, entitiesSelector: dictionarySelector<T>): listSelector<T> {
        return createSelector(
            idsSelector,
            entitiesSelector,
            this.activeUserMembershipsByAccount,
            this.isAccountOwnerByAccount,
            this.selectedUser,
            (state: VasState) => state,
            (ids, entities, activeUserMembershipsByAccount, isAccountOwnerByAccount, user, state) => {

                const jobIds = this.jobQueryFactory.items(state).map(job => job.id);

                return ids
                    .map(id => entities[id])
                    .filter(item => {

                        const membership = activeUserMembershipsByAccount[item.account];
                        const isOwner = isAccountOwnerByAccount[item.account];

                        if (!membership) {
                            return false;
                        }

                        if (isOwner || membership.admin) {
                            return true;
                        }

                        if (!isInArray(item.job, jobIds)) {
                            AppConfig.debugQueries && console.log("rao job-data jobs check failed", item);
                            return false;
                        }

                        if (!this.customChecks.length) {
                            return true;
                        } else {
                            return this.customChecks.length === this.customChecks
                                .filter(check => check.hasAccess(item, membership, user))
                                .length;
                        }
                    });
            }
        );
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/report/job-data-acl.filter.ts